(function () {
    angular.module('tmx-app').factory('SessionHistoryReportService', ['$http', 'APP_CONSTANTS', 'tmxResource', '$filter', '$q', 'tmxUtility', '$mdMedia', 'lookupService',
        function ($http, APP_CONSTANTS, tmxResource, $filter, $q, tmxUtility, $mdMedia, lookupService) {

            var Report = tmxResource("report");
            // Report.GetProductSkuByWarehouse = GetProductSkuByWarehouse;
            // Report.GetProductSkuByWarehouseId = GetProductSkuByWarehouseId;
            // Report.setLookups = setLookups;
            Report.exportSessionHistoryReport = exportSessionHistoryReport;
            function exportSessionHistoryReport(loanapplicationnumber,branchid,nationalid,offset,fromdate,todate) {

                if(!loanapplicationnumber){
                    loanapplicationnumber=null;
                }

                if(!branchid){
                    branchid=null;
                }
                
                if(!nationalid){
                    nationalid=null;
                }

                if(!offset){
                    offset=null;
                }
                
                if(!fromdate){
                    fromdate=null;
                }

                if(!todate){
                    todate=null;
                }

                var objArgs = {
                    "LoanApplicationNumber":loanapplicationnumber,
                    "BranchId":branchid,
                    "NationalId":nationalid,
                    "offset":offset,
                    "FromDate":fromdate,
                    "ToDate":todate
                };

                var filters = {
                    "StoredProcedure": "sp_operation_report",
                    "Arguments": objArgs,
                    "ReportName": "Operation_Report",
                    "PageOrientation": "Landscape"
                };

                //var url = '/ExportLoanReport/' + userid + '/'+ deliveryManId + '/' + startdate + '/' + enddate + '/' + new Date().getTimezoneOffset();
                $http.post(APP_CONSTANTS.backend + 'report/ReportPDF' , filters , { responseType: 'arraybuffer' })
                    .success(function (data) {
                        var file = new Blob([data], { type: 'application/pdf' });
                        saveAs(file, 'SessionHistoryReport.pdf');
                    });
            }

            Report.GridColumns = [


                {
                    field: tmxUtility.formatColumnName('RoleName'),
                    title: "RoleName",
                    type: "text",
                        //  width: $mdMedia('gt-sm') ? '10%' : '150px',
                    template: "<span >{{dataItem[SessionHistoryReportCtrl.formatColumnName('RoleName')]}}</span>",
                    scrollable: false,
                    search: true,
                    headerTemplate: "<span>Role</span>"                        
                },
                {
                    field: tmxUtility.formatColumnName('UserName'),
                    title: "UserName",
                    type: "integer",
                        //  width: $mdMedia('gt-sm') ? '10%' : '150px',
                    template: "<span >{{dataItem[SessionHistoryReportCtrl.formatColumnName('UserName')]}}</span>",
                    scrollable: false,
                    search: true,
                    headerTemplate: "<span>User Name</span>"                        
                },
                {
                    field: tmxUtility.formatColumnName('LoginDate'),
                    title: "LoginDate",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    template: "<span >{{SessionHistoryReportCtrl.formatDateTime(dataItem[SessionHistoryReportCtrl.formatColumnName('LoginDate')])}}</span>",
                    scrollable: false,
                    search: true,
                    headerTemplate: "<span>Login Time</span>"
                },
                {
                    field: tmxUtility.formatColumnName('LogoutDate'),
                    title: "LogoutDate",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    template: "<span >{{SessionHistoryReportCtrl.formatDateTime(dataItem[SessionHistoryReportCtrl.formatColumnName('LogoutDate')])}}</span>",
                    scrollable: false,
                    search: true,
                    headerTemplate: "<span>Logout Time</span>"
                },
                {
                    field: tmxUtility.formatColumnName('EventName'),
                    title: "EventName",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    template: "<span >{{dataItem[SessionHistoryReportCtrl.formatColumnName('EventName')]}}</span>",
                    scrollable: false,
                    search: true,
                    headerTemplate: "<span>Event</span>"
                }
            ];


            return Report;

        }]);
})();